"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'avatar.tooltips.talk': 'Start conversation with this avatar',
    'avatar.tooltips.preview': 'Preview avatar details',
    'avatar.tooltips.edit': 'Edit avatar settings',
    'avatar.tooltips.delete': 'Delete this avatar',
};
